import React from "react";
import { Box, Stack, TablePagination, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const TableViewPagination = () => {
  const [page, setPage] = React.useState(2);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Table Pagination
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          language="js"
          title={"Table Pagination"}
          value={
            'import {Box, Stack, TablePagination, Typography} from "@mui/material";\n\n\n\n' +
            "const [page, setPage] = React.useState(2);\n" +
            "  const [rowsPerPage, setRowsPerPage] = React.useState(10);\n" +
            "\n" +
            "  const handleChangePage = (event, newPage) => {\n" +
            "    setPage(newPage);\n" +
            "  };\n" +
            "\n" +
            "  const handleChangeRowsPerPage = (event) => {\n" +
            "    setRowsPerPage(parseInt(event.target.value, 10));\n" +
            "    setPage(0);\n" +
            "  };\n\n\n\n" +
            "           <TablePagination\n" +
            '            component="div"\n' +
            "            count={100}\n" +
            "            page={page}\n" +
            "            onPageChange={handleChangePage}\n" +
            "            rowsPerPage={rowsPerPage}\n" +
            "            onRowsPerPageChange={handleChangeRowsPerPage}\n" +
            "          />"
          }
        >
          <TablePagination
            component="div"
            count={100}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default TableViewPagination;
